var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download-01 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.84992 34.7788C7.57025 34.7245 7.30671 34.6069 7.07944 34.4351C6.85217 34.2633 6.66718 34.0419 6.53862 33.7876C6.41232 33.5235 6.33979 33.2368 6.32523 32.9444C6.32523 30.5352 6.32523 28.1638 6.32523 25.7718C6.32258 25.7305 6.32258 25.6891 6.32523 25.6479H9.95283V31.1031H30.1215V25.6479H33.7938V32.5314C33.7938 33.8496 33.4772 34.3073 32.2485 34.7651L7.84992 34.7788Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.3017 18.317V17.9728C17.3017 14.2007 17.3017 10.4296 17.3017 6.65978C17.3017 5.85785 17.6286 5.53088 18.4271 5.53088H21.745C22.4333 5.53088 22.7982 5.87506 22.7982 6.59094V18.317H23.1217C24.1783 18.317 25.2384 18.317 26.2984 18.317C26.499 18.2921 26.7023 18.3305 26.88 18.4268C27.0577 18.523 27.2009 18.6723 27.2896 18.8539C27.3744 19.0396 27.3971 19.2477 27.3543 19.4473C27.3115 19.6469 27.2056 19.8275 27.0522 19.9621L20.8329 27.0418C20.3407 27.6063 19.7625 27.6097 19.2738 27.0418C17.1927 24.6762 15.1127 22.3071 13.0339 19.9346C12.8881 19.8029 12.7877 19.6284 12.7469 19.4362C12.7061 19.244 12.727 19.0438 12.8068 18.8642C12.892 18.6813 13.0325 18.5297 13.2085 18.4309C13.3845 18.3321 13.5871 18.2911 13.7877 18.3135C14.8477 18.3135 15.9078 18.3135 16.9644 18.3135L17.3017 18.317Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.64f517cf942efb9de42e906a1cc1857f.svg";
export { ForwardRef as ReactComponent };